import { render, staticRenderFns } from "./Leadership.vue?vue&type=template&id=38bf9efa&scoped=true&"
import script from "./Leadership.vue?vue&type=script&lang=js&"
export * from "./Leadership.vue?vue&type=script&lang=js&"
import style0 from "./Leadership.vue?vue&type=style&index=0&id=38bf9efa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf9efa",
  null
  
)

export default component.exports